import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/app/(astro routes)/healing/[subPage]/page.tsx")